import { routerMiddleware } from 'connected-react-router';
export const buildRouterMiddleware = (history) => {
    return routerMiddleware(history);
};
export const createDynamicModuleLoaderRouterMiddleWare = (history) => ({
    id: 'startup-connected-react-router',
    middlewares: [buildRouterMiddleware(history)],
});
